<template>
  <div id="dashboard" style="height: 100%">
    <v-app-bar flat app light color="white">
      <v-app-bar-nav-icon
        class="md:hidden"
        @click.stop="sidebarMenu = !sidebarMenu"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="d-flex align-center">
        <a class="d-flex align-center" href="https://snappyexchange.com">
          <v-img
            :src="logo"
            width="170"
            contain
            class="d-none d-md-block"
          ></v-img>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-badge
        :content="notifications.length"
        :value="notifications.length > 0"
        overlap
        color="red"
      >
        <v-icon icon @click.stop="notificationModal = !notificationModal"
          >mdi-bell-outline
        </v-icon>
      </v-badge>
      <v-menu
        transition="scale-transition"
        origin="center center"
        left
        bottom
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon class="mx-2" v-bind="attrs" v-on="on">
            <v-icon>mdi-account-outline</v-icon>
          </v-btn>
        </template>
        <v-list dense class="text-center" elevation="2" min-width="100">
          <v-list-item ripple="" to="/user/settings">
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item ripple @click="logout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- Notification -->
    <v-navigation-drawer
      width="300"
      v-model="notificationModal"
      temporary
      app
      right
    >
      <v-sheet color="py-4 pa-4">
        <h4 class="text-h6 text-right py-2">Notification</h4>
        <v-divider class="mb-2"></v-divider>
        <v-card
          v-for="notification in notifications"
          :key="notification._id"
          class="my-2"
        >
          <v-toolbar color="primary">
            <p class="white--text overline mb-0">{{ notification.title }}</p>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  @click="readNotification(notification._id)"
                  dark
                  :disabled="marking"
                  v-bind="attrs"
                  v-on="on"
                  color="error"
                  >mdi-close
                </v-icon>
              </template>
              <span>Mark as Read</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <p class="text-capitalize grey--text my-2">
              {{ timeAgo.format(new Date(notification.createdAt)) }}
            </p>

            <p class="grey--text text--darken-1 mb-0">
              {{ notification.message }}
            </p>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-navigation-drawer>
    <!-- Sidebar -->
    <v-navigation-drawer
      v-model="sidebarMenu"
      app
      class="sidebar"
      style="height: 100%; max-height: 100%"
    >
      <!-- Old sidebar code commented out for backup -->
      <!--
      <v-list-item class="px-2" @click="toggleMini = !toggleMini">
        <v-btn icon small>
          <v-icon class="white--text"
            >{{ toggleMini ? 'mdi-chevron-right' : 'mdi-chevron-left' }}
          </v-icon>
        </v-btn>
      </v-list-item>
      <div class="py-3 text-center">
        <v-list-item class="px-2">
          <v-list-item-avatar
            class="mx-auto"
            :width="toggleMini ? '' : 105"
            :height="toggleMini ? '' : 105"
          >
            <v-img :src="user.image"></v-img>
          </v-list-item-avatar>
        </v-list-item>
        <v-list-item link to="/user/settings">
          <v-list-item-content>
            <span
              v-if="
                user.fname == 'UNDEFINED' ||
                user.lname == 'UNDEFINED' ||
                !user.fname ||
                !user.lname
              "
              class="subtitle text-error white--text"
              >{{ toggleMini ? '' : 'Kindly update your profile' }}</span
            >
            <v-list-item-title v-else class="title white--text">
              {{
                user.fname == 'UNDEFINED' ||
                user.lname == 'UNDEFINED' ||
                !user.fname
                  ? ``
                  : ` ${user.fname}`
              }}
            </v-list-item-title>
            <v-list-item-subtitle class="white--text"
              >{{ user.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="toggleRankDialog">
          <v-list-item-content>
            <v-chip color="accent rank" v-if="currentRank">
              {{ currentRank.title }}
            </v-chip>
          </v-list-item-content>
        </v-list-item>
      </div>
      <v-list dark>
        ...
      </v-list>
      -->

      <!-- New Sidebar Design -->
      <div class="sidebar-profile-card">
        <div class="sidebar-avatar">
          <span class="sidebar-avatar-initials">
            {{
              (user.fname && user.fname[0] ? user.fname[0] : '') +
              (user.lname && user.lname[0] ? user.lname[0] : '')
            }}
          </span>
        </div>
        <div class="sidebar-profile-info">
          <div class="sidebar-profile-name">{{ user.fname }}</div>
          <div class="sidebar-profile-email" :title="user.email">
            {{ user.email }}
          </div>
          <div
            @click="toggleRankDialog"
            class="sidebar-profile-badge cursor-pointer"
          >
            {{ currentRank ? currentRank.title : 'Rookie' }}
          </div>
        </div>
      </div>
      <div class="sidebar-menu">
        <div
          v-for="item in menus"
          :key="item.title"
          :class="[
            'sidebar-menu-item',
            { active: $route.path.split('/').includes(item.href.split('/')[2]) }
          ]"
          @click="$router.push(item.href)"
        >
          <v-icon class="sidebar-menu-icon">{{ item.icon }}</v-icon>
          <span class="sidebar-menu-title">{{ item.title }}</span>
        </div>
      </div>
    </v-navigation-drawer>

    <v-main
      class="grey main-content lighten-4 pb-0 overflow-hidden"
      style="height: 100%"
    >
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition>
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
      <!-- <Footer /> -->
    </v-main>

    <v-dialog
      @click:outside="toggleRankDialog"
      v-model="viewRankDialog"
      max-width="500"
    >
      <v-card v-if="currentRank !== null">
        <v-container>
          <div class="py-10">
            <v-img
              :src="currentRank.badge"
              :alt="currentRank.title"
              width="105"
              height="105"
              style="margin: 0 auto"
            />
          </div>
          <div class="text-center px-10">
            You are a
            <span class="primary--text bold">{{ currentRank.title }}</span>
            trade up to
            <span class="primary--text bold">{{
              ranksAmount.minTransactionAmount
            }}</span>
            to become a
            <span class="primary--text bold">{{ nextRank.title }}</span
            >, and earn Cashback Points.
          </div>
          <div class="text-center">
            <v-btn
              color="primary"
              class="mt-5"
              href="https://blog.snappyexchange.com/category/userranking"
              target="_blank"
            >
              Learn More
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Footer from '../components/footer/footer.vue'
// import Sidebar from '../components/sidebar/sidebar.vue'
import { mapState, mapActions } from 'vuex'
import rank from '../api/users/rank'
import logo from '../assets/logo_snappy.png'
import { getCurrencyCode } from '../utils/countryHelpers'
import { numberWithCommas } from '../utils/helpers'
import timeAgo from '../utils/timeAgo'

export default {
  name: 'user-dashboard',
  data: () => ({
    numberWithCommas,
    marking: false,
    timeAgo,
    notificationModal: false,
    sidebarMenu: true,
    toggleMini: false,
    logo,
    userTawk: {},
    currentRank: null,
    totalAmountTrader: 0,
    nextRank: null,
    menus: [
      {
        title: 'Dashboard',
        href: '/user/dashboard',
        icon: 'mdi-view-dashboard'
      },
      {
        title: 'Transactions',
        href: '/user/transactions',
        icon: 'mdi-bank-transfer'
      },
      {
        title: 'Wallet',
        href: '/user/wallet',
        icon: 'mdi-wallet-outline'
      },
      {
        title: 'Reward',
        href: '/user/reward',
        icon: 'mdi-gift-outline'
      },
      {
        title: 'Our Services',
        href: '/user/products',
        icon: 'mdi-apps'
      },
      {
        title: 'Rates',
        href: '/user/rates',
        icon: 'mdi-chart-histogram'
      },
      {
        title: 'Leaderboards',
        href: '/user/leaderboard',
        icon: 'mdi-chart-line-variant'
      },
      {
        title: 'User Level',
        href: '/user/level',
        icon: 'mdi-chart-line-variant'
      },
      {
        title: 'Download our app',
        href: '/user/download',
        icon: 'mdi-download'
      },
      {
        title: 'Promo Code',
        href: '/user/promo-codes',
        icon: 'mdi-percent-outline'
      },
      {
        title: 'Promo',
        href: '/user/promo',
        icon: 'mdi-account-multiple-outline'
      },
      // {
      //   title: 'Message',
      //   href: '/user/messages',
      //   icon: 'mdi-android-messages',
      //   children: [
      //     {
      //       title: 'Manage Message',
      //       href: '/user/messages/create-message'
      //     },
      //     {
      //       title: 'Create Testimonial',
      //       href: '/user/messages/create-testimonial',
      //       icon: 'mdi-android-messages'
      //     }
      //   ]
      // },
      {
        title: 'Earn With Snappy',
        href: '/user/referral-system',
        icon: 'mdi-account-arrow-right'
      },
      {
        title: 'Contact Support',
        href: '/user/contact-support',
        icon: 'mdi-face-agent'
      },
      {
        title: 'Settings',
        href: '/user/settings',
        icon: 'mdi-account-cog'
      }
    ]
  }),
  components: {
    // Sidebar
    // Footer
  },
  created() {
    this.sidebarMenu = !this.$vuetify.breakpoint.smAndDown
    this.getCurrentRank()
  },
  mounted() {
    this.$store.dispatch('user/getNotifications')
    // console.log(!this.$vuetify.breakpoint.smAndDown)
    // const tawk = document.createElement('script')
    // tawk.setAttribute('type', 'text/javascript')
    // tawk.innerText =
    //   "var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); (function(){ var s1=document.createElement('script'),s0=document.getElementsByTagName('script')[0]; s1.async=true; s1.src='https://embed.tawk.to/5ecae123c75cbf1769eee9c3/default'; s1.charset='UTF-8'; s1.setAttribute('crossorigin','*'); s0.parentNode.insertBefore(s1,s0); })();"
    // document.head.appendChild(tawk)

    const freshworks = document.createElement('script')
    freshworks.setAttribute('type', 'text/javascript')
    freshworks.setAttribute('src', '//uae.fw-cdn.com/40167963/102822.js')
    freshworks.setAttribute('chat', 'true')
    document.head.appendChild(freshworks)
  },
  methods: {
    async toggleRankDialog() {
      this.$store.commit('user/toggleRankDialog')
    },
    async getCurrentRank() {
      const res = await rank.rankApi().getUserCurrentRank()

      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          status: true,
          error: true
        })

        return
      }

      this.currentRank = res.data.data.currentRank
      this.nextRank = res.data.data.nextRank
      this.totalAmountTrader = res.data.data.totalAmount
    },
    readNotification(id) {
      this.marking = true
      this.markNotificationAsRead([id])
      setTimeout(() => {
        this.marking = false
      }, 3000)
    },
    logout() {
      setTimeout(() => {
        this.$router.push('/auth')
        this.$store.commit('user/setToken', '')
        this.$store.commit('user/updateUserData', {})
      }, 1500)
    },
    ...mapActions({
      markNotificationAsRead: 'user/markNotificationAsRead'
    })
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      alert: (state) => state.alert,
      wallet: (state) => state.user.wallet,
      notifications: (state) => state.user.notifications,
      siteData: (state) => state.user.siteSettings,
      countrySetting: (state) => state.user.countryCurrency,
      viewRankDialog: (state) => state.user.viewRankDialog,
      ranksAmount() {
        const currentRankValue = this.currentRank?.values.find(
          (value) => value.currency === getCurrencyCode(this.userCountry)
        )

        const nextRankValue = this.nextRank?.values.find(
          (value) => value.currency === getCurrencyCode(this.userCountry)
        )

        return {
          amountNeed: numberWithCommas(
            currentRankValue.lowerLimit - this.totalAmountTrader
          ),
          minTransactionAmount: `${getCurrencyCode(
            this.userCountry
          )} ${numberWithCommas(nextRankValue.lowerLimit)}`
        }
      }
    })
  },

  head: {
    title: 'SnappyExchange'
  }
}
</script>

<style>
.border {
  background-color: #fff;
}

.rank {
  font-size: 1.5rem;
  font-weight: 500;
  color: #fff;
  text-align: center;
  margin-bottom: 0.5rem;
  justify-content: center;
  align-items: center;
}

.bold {
  font-weight: 600;
}

.sidebar {
  background-color: #d9e4ea !important;
  padding-top: 24px;
  padding-bottom: 24px;
}

.sidebar-profile-card {
  background: #fff;
  border-radius: 24px;
  padding: 24px 16px 16px 16px;
  margin: 0 16px 32px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  overflow: hidden;
}

.sidebar-avatar {
  background: #5a35f7;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.sidebar-avatar-initials {
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
}

.sidebar-profile-info {
  text-align: left;
  width: 100%;
  min-width: 0;
}

.sidebar-profile-name {
  font-size: 1.25rem;
  font-weight: 600;
  color: #555;
}

.sidebar-profile-email {
  font-size: 0.95rem;
  color: #888;
  margin-bottom: 8px;
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.sidebar-profile-badge {
  background: #ffe082;
  color: #7a5d00;
  border-radius: 20px;
  padding: 4px 16px;
  font-size: 1rem;
  font-weight: 500;
  display: inline-block;
}

.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 16px;
}

.sidebar-menu-item {
  display: flex;
  align-items: center;
  background: #1400c8;
  color: #fff;
  border-radius: 20px;
  padding: 16px 20px;
  font-size: 1.15rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.sidebar-menu-item .sidebar-menu-icon {
  margin-right: 16px;
  color: #fff;
}

.sidebar-menu-item.active {
  background: #fff;
  color: #1400c8;
  font-weight: 700;
}

.sidebar-menu-item.active .sidebar-menu-icon {
  color: #1400c8;
}

.main-content {
  background-color: #fcfcfc;
}
</style>
